const SET_PAGE = 'setPage'
const SET_PAGE_SIZE = 'setPageSize'
const SET_SORT = 'setSort'
const SET_LOADING = 'setLoading'
const SET_FILTERS = 'setFilters'

const state = {
  page: 1,
  pageSize: 10,
  sort: '',
  loading: false,
  filters: {}
}

const mutations = {
  [SET_PAGE] (state, page) {
    state.page = page
  },
  [SET_PAGE_SIZE] (state, pageSize) {
    state.pageSize = pageSize
  },
  [SET_SORT] (state, sort) {
    state.sort = sort
  },
  [SET_LOADING] (state, flag) {
    state.loading = flag
  },
  [SET_FILTERS] (state, filters) {
    state.filters = filters
  }
}

export default {
  namespaced: true,
  state,
  mutations
}

export {
  SET_PAGE,
  SET_PAGE_SIZE,
  SET_SORT,
  SET_LOADING,
  SET_FILTERS
}



// WEBPACK FOOTER //
// ./src/store/modules/table.js